import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  breadcrumbarray:any=[];
  breadcrumb:any= [];
  length:number=0;
  comp:boolean=false;

  index=1;
    test: number=0;
    categorytab: boolean=true;
    smartreportertab:boolean=true;
    mycategoryiestab:boolean=true;
  stylingtab: boolean=false;
  idname: any;
  constructor() {
    //this.breadcrumb[0]={"title":"home","displayName":"Home","link":true}
    //this.breadcrumb[1]={"title":"Search","displayName":"Search","link":true}
   }

   tempadd()
   {
    return this.breadcrumb;
   }
   add(title:any,index:number,displayName:any,link:boolean){
    console.log(this.breadcrumb)

     this.breadcrumb[index]= {"title":title,"displayName":displayName,"link":link}
  this.index=index;
  this.breadcrumb=this.breadcrumb.filter((item, i, arr) => arr.findIndex((t) => (t.displayName === item.displayName && t.title === item.title)) === i)
console.log(this.breadcrumb)
}
 tabarry(data:any){
   this.breadcrumbarray.push(data);
 }
}
